import ResumeItem from '@/common/components/ResumeItem'
import CreateForwardingDirectiveEntryFormStepCompleted from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryFormStepCompleted'
import { MaintenanceForwardingsDirectiveFromSteps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { DirectiveComplexityValidationSchema } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/schemas/maintenanceForwardingDirectiveSteps.schema'
import { MaintenanceForwardingsDirectiveFormStepProps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwardingsDirectiveFormStep.type'
import { useFormContext, useWatch } from 'react-hook-form'

const DirectiveComplexityFormStepCompleted = ({
  stepIndex,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.DirectiveComplexity>) => {
  const { control } = useFormContext<DirectiveComplexityValidationSchema>()

  const { complexity: watchComplexity } = useWatch({
    control,
  })

  return (
    <CreateForwardingDirectiveEntryFormStepCompleted
      stepIndex={stepIndex}
      title="Configuração de Diagnóstico"
      body={
        <div>
          <ResumeItem
            label="Complexidade do diagnóstico"
            value={(watchComplexity?.label as string | JSX.Element) || '--'}
            className="text-sm"
          />
        </div>
      }
    />
  )
}

export default DirectiveComplexityFormStepCompleted
